import React, { useState } from "react";

import ActiveJobs from "./ActiveJobs";
const ActiveJobsMainComponent = ({}) => {
  return (
    <div className="pt-[83px] max-w-[1440px] m-auto md:px-6 px-4">
    {" "}
    <ActiveJobs />
  </div>
  );
};

export default ActiveJobsMainComponent;
